import { call, put, takeLatest, all, select, delay } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* apiRunner(apiType, payload, responseReducer) {
  yield put(Actions.setLoader({ showLoader: true }));
  try {
    const { data } = yield call(apiType, payload);
    if (responseReducer) {
      yield put(responseReducer(data));
    }
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error);
  }
}

function* fetchFactoryAutomationEquipments({ factoryId }) {
  try {
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: true }));
    const { data } = yield call(api.get, {
      route: `Equipment/getautomationequipments/` + factoryId,
    });
    const result = data ? data.toJS() : [];

    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: false }));
    yield put(Actions.setFactoryAutomationEquipments({ automationEquipments: result }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* fetchAutomationEquipmentConfiguration({ lineId, jobId }) {
  try {
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: true }));
    const { data } = yield call(api.get, {
      route: `LineJob/getautomationmodaldata/${lineId}/${jobId}`,
    });
    const result = data ? data.toJS() : [];

    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: false }));
    yield put(Actions.setAutomationEquipmentConfiguration({ equipmentConfiguration: result }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* attachAutomationToLine({ request, callback }) {
  try {
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: true }));
    const { data } = yield call(api.put, {
      route: `LineJob/attachautomationtoline/${request.lineId}`,
      data: request,
    });
    const response = data ? data.toJS() : {};
    if (callback) {
      callback(response);
    }
    if (response.code == CONSTANT_VARIABLES.Http_Status_Code_OK) {
      notification('success', CONSTANT_VARIABLES.AUTOMATION_HAS_ATTACHED_TO_LINE_SUCCESSFULLY, '');
    } else {
      notification('error', 'Error in attaching the automation', response.message);
    }
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: false }));
  } catch (err) {
    console.warn(err); // Handle exception
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: false }));
  }
}

function* editToolCavity({ toolCavity }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: 'job/jobtoolcavity',
      data: toolCavity,
    });
    yield put(Actions.fetchToolCavityTable());
    notification('success', CONSTANT_VARIABLES.CAVITY_UPDATED, '');
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchToolCavityTable() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Job/JobToolCavities/`,
    });
    const toolCavityTable = data.toJS();
    yield put(Actions.setToolCavityTable({ toolCavityTable }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* detachAutomationFromLine({ request, callback }) {
  try {
    const { lineId, lineJobId, equipmentId } = request;
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: true }));
    const { data } = yield call(api.put, {
      route: `LineJob/detachautomationfromline/${lineId}/${lineJobId}/${equipmentId}`,
    });
    const response = data ? data.toJS() : {};
    if (callback) {
      callback(response);
    }
    if (response.code == CONSTANT_VARIABLES.Http_Status_Code_OK) {
      notification('success', CONSTANT_VARIABLES.AUTOMATION_HAS_DETACHED_FROM_LINE_SUCCESSFULLY, '');
    } else {
      notification('error', 'Error in detaching the automation', response.message);
    }
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: false }));
  } catch (err) {
    console.warn(err); // Handle exception
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: false }));
  }
}
function* automationReconciliationAndDetachEquipmentFromLine({ request, callback }) {
  try {
    const { lineId } = request;
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: true }));
    const { data } = yield call(api.put, {
      route: `LineJob/automationreconciliation/${lineId}`,
      data: request,
    });
    const response = data ? data.toJS() : {};

    if (response.code == CONSTANT_VARIABLES.Http_Status_Code_OK) {
      notification('success', CONSTANT_VARIABLES.AUTOMATION_HAS_RECONCILIATED_SUCCESSFULLY, '');
      yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: false }));
      if (callback) {
        callback();
      }
    } else {
      notification('error', 'Error in detaching the automation', response.message);
      yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: false }));
    }
  } catch (err) {
    console.warn(err); // Handle exception
    yield put(Actions.setMovingAutomationLoader({ movingAutomationLoader: false }));
  }
}

function* fetchFactoryEfficiencyGrid({ params }) {
  let token = true,
    getToken;
  while (token) {
    try {
      const { factoryId, groupIds, state, reasonCode } = params;
      let query = 'factoryId=' + factoryId;

      if (groupIds) {
        query += '&groupIds=' + groupIds;
      }
      if (state != null) {
        query += '&state=' + state;
      }
      if (reasonCode) {
        query += '&reasonCode=' + reasonCode;
      }

      yield apiRunner(
        api.get,
        {
          route: `dashboards/factoryefficiencyoee?` + query,
        },
        data => Actions.setFactoryEfficiencyGrid({ factoryEfficiencyGrid: data.toJS() })
      );
      yield put(Actions.fetchToolCavityTable());
      yield delay(60000, true);
      getToken = state => state.services.common.getIn(['ajaxCallfactoryefficiency']);
      token = yield select(getToken);
    } catch (err) {
      console.warn(err); // Handle exception
      yield put(Actions.setLoader({ showLoader: false }));
    }
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_FACTORY_EFFICIENCY_GRID, fetchFactoryEfficiencyGrid)]);
  yield all([takeLatest(ActionTypes.FETCH_FACTORY_AUTOMATION_EQUIPMENTS, fetchFactoryAutomationEquipments)]);
  yield all([takeLatest(ActionTypes.FETCH_AUTOMATION_EQUIPMENT_CONFIGURATION, fetchAutomationEquipmentConfiguration)]);
  yield all([takeLatest(ActionTypes.EDIT_TOOL_CAVITY, editToolCavity)]);
  yield all([takeLatest(ActionTypes.FETCH_TOOL_CAVITY_TABLE, fetchToolCavityTable)]);
  yield all([takeLatest(ActionTypes.ATTACH_AUTOMATION_EQUIPMENT_TO_LINE, attachAutomationToLine)]);
  yield all([takeLatest(ActionTypes.DETACH_AUTOMATION_EQUIPMENT_FROM_LINE, detachAutomationFromLine)]);
  yield all([
    takeLatest(
      ActionTypes.AUTOMATION_RECONCILIATION_AND_DETACH_EQUIPMENT_FROM_LINE,
      automationReconciliationAndDetachEquipmentFromLine
    ),
  ]);
}
